import { Dialog, DialogContent } from '@mui/material';
import { ModalHeader } from 'layouts/Generic/modal-header';
import * as React from 'react';
import { TerminalCredential } from 'services/clients/credentials';
import fonts from 'styles/typography.module.css';
import { UpdateForm } from './UpdateForm';

interface Props {
  credential?: TerminalCredential;
  onClose: () => void;
}

export const UpdateCredential: React.FC<Props> = (props) => {
  const { credential, onClose } = props;

  const open = !!credential;

  if (!credential) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={fonts.font}
      classes={{ paper: 'w-[640px] max-w-[80%]' }}
    >
      <ModalHeader onClose={onClose}>
        <p className="font-bold">
          {credential.status === 'missing' ? 'Add' : 'Update'} appointment system login for{' '}
          <a
            href={credential?.portal.link}
            target="_blank"
            rel="noreferrer"
            className="text-blue-900 underline"
          >
            {credential?.portal.displayName}
          </a>
        </p>
      </ModalHeader>
      <DialogContent dividers>
        <UpdateForm onClose={onClose} credential={credential} />
      </DialogContent>
    </Dialog>
  );
};
UpdateCredential.displayName = 'UpdateCredential';
